// Caminhos do legado (router.tsx:1455-1512). O hub só tem o card Dataprev e leva direto à lista.
export const CONCILIATION_PATH = '/gestao-carteira/conciliacao';
export const DATAPREV_PATH = `${CONCILIATION_PATH}/dataprev`;
export const NEW_CONCILIATION_PATH = `${DATAPREV_PATH}/nova-conciliacao`;
/** Bolsão dentro do órgão (SuspenseAccount/constants.ts:1-5): outro órgão ganharia o seu em `conciliacao/<orgao>/bolsao`. */
export const SUSPENSE_ACCOUNT_PATH = `${DATAPREV_PATH}/bolsao`;
export const suspenseAccountPath = (id: string) => `${SUSPENSE_ACCOUNT_PATH}/${encodeURIComponent(id)}`;

export const conciliationPath = (id: string) => `${DATAPREV_PATH}/${encodeURIComponent(id)}`;

/** Abas do detalhe pelo caminho antigo (router.tsx:1491-1510): hoje redirecionam para `?tab=` (S29). */
export const LEGACY_TAB_SEGMENTS = ['inconsistencias', 'nao-encerradas', 'linha-de-repasse', 'historico'] as const;
